import IconWrapper from './IconWrapper';

const IconExchange = IconWrapper({
  name: 'add',
  source: (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.261906 3.18057C0.095672 3.32306 0 3.53107 0 3.75001C0 3.96896 0.0956719 4.17697 0.261906 4.31946L3.7619 7.31946C4.0764 7.58902 4.54987 7.5526 4.81944 7.23811C5.08901 6.92361 5.05259 6.45014 4.73809 6.18057L2.77744 4.50001H10C11.2426 4.50001 12.25 5.50737 12.25 6.75001C12.25 7.16423 12.5858 7.50001 13 7.50001C13.4142 7.50001 13.75 7.16423 13.75 6.75001C13.75 4.67895 12.0711 3.00001 10 3.00001H2.77744L4.73809 1.31946C5.05259 1.04989 5.08901 0.576414 4.81944 0.26192C4.54987 -0.0525743 4.0764 -0.0889956 3.7619 0.180571L0.261906 3.18057ZM19.7381 12.8195C19.9043 12.677 20 12.469 20 12.25C20 12.0311 19.9043 11.8231 19.7381 11.6806L16.2381 8.68057C15.9236 8.411 15.4501 8.44742 15.1806 8.76192C14.911 9.07641 14.9474 9.54989 15.2619 9.81945L17.2226 11.5H10C8.75736 11.5 7.75 10.4927 7.75 9.25001C7.75 8.8358 7.41422 8.50001 7 8.50001C6.58579 8.50001 6.25 8.8358 6.25 9.25001C6.25 11.3211 7.92893 13 10 13H17.2226L15.2619 14.6806C14.9474 14.9501 14.911 15.4236 15.1806 15.7381C15.4501 16.0526 15.9236 16.089 16.2381 15.8195L19.7381 12.8195Z"
      />
    </svg>
  ),
});

export default IconExchange;
